// extracted by mini-css-extract-plugin
export var defaultWrapper = "_mw-3";
export var downloadButton = "_mw-4";
export var fileContainer = "_mw-9 _mw-7";
export var fileContainerBase = "_mw-7";
export var fileContainerFixedHeight = "_mw-8 _mw-7";
export var fileInfo = "_mw-5";
export var fileInfoWidthRestricted = "_mw-6";
export var fileType = "_mw-1";
export var fileTypeName = "_mw-2";
export var image = "_mw-0";
export var link = "_mw-b";
export var overflowEllipsis = "_mw-a";